export enum WidgetType {
  BUTTON_V1 = 'button_v1',
  BUTTON_V2 = 'button_v2',
  BUTTON_V3 = 'button_v3',
}
